(() => {
  if (customElements.get('audrey-sale-countdown')) return;
  class AudreySaleCountdown extends HTMLElement {
    connectedCallback() {
      this.formatter = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Toronto', year: 'numeric', month: '2-digit',
        day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit',
        hourCycle: 'h23'
      });
      this.update();
      clearInterval(this.interval);
      this.interval = setInterval(() => this.update(), 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
    parts(date) {
      return Object.fromEntries(this.formatter.formatToParts(date).filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
    }
    remainingSeconds(now) {
      const current = this.parts(now);
      const midnight = Date.UTC(current.year, current.month - 1, current.day + 1);
      let target = midnight;
      for (let i = 0; i < 3; i++) {
        const local = this.parts(new Date(target));
        target += midnight - Date.UTC(local.year, local.month - 1, local.day, local.hour, local.minute, local.second);
      }
      return Math.max(0, Math.ceil((target - now.getTime()) / 1000));
    }
    update() {
      const seconds = this.remainingSeconds(new Date());
      this.textContent = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60].map(n => String(n).padStart(2, '0')).join(':');
    }
  }
  customElements.define('audrey-sale-countdown', AudreySaleCountdown);
})();
